import { useGetOne } from 'react-admin';

export function useCompany(id: number | undefined) {
  return useGetOne('Company', { id }, { enabled: !!id });
}
